<div class="popup-header">
    <div class="title">
        Form submitted
    </div>
</div>

<div mat-dialog-content align="center">
    <br>

    <button class="theme-button"  mat-button (click)="onNoClick()">Go back to management</button>
    <br>
    <p></p>
</div>
<div mat-dialog-actions align="center">

</div>